import { useState } from 'react';
import { useNotification } from '../../contexts/NotificationContext';
import { QrCode } from 'lucide-react';

export const QRCodeRedemption = () => {
  const [couponCode, setCouponCode] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { addNotification } = useNotification();
  const redeemCode = (code: string): boolean => {
    console.log('Redeem code functionality not implemented yet:', code);
    return false;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!couponCode.trim()) {
      addNotification('Please enter a valid coupon code', 'error');
      return;
    }
    
    setIsSubmitting(true);
    
    // Simulate a bit of loading for better UX
    setTimeout(() => {
      const success = redeemCode(couponCode);
      
      if (success) {
        addNotification('XP awarded successfully!', 'success');
        setCouponCode('');
      } else {
        addNotification('Invalid or already redeemed coupon code', 'error');
      }
      
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Redeem XP Code</h2>
      <p className="text-gray-600 mb-6">
        Enter a coupon code or scan a QR code to earn XP rewards
      </p>
      
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col md:flex-row gap-4">
          <div className="flex-grow relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <QrCode className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
              placeholder="Enter coupon code"
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              disabled={isSubmitting}
            />
          </div>
          
          <button
            type="submit"
            disabled={isSubmitting}
            className={`px-4 py-2 rounded-md text-white font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${
              isSubmitting
                ? 'bg-indigo-400 cursor-not-allowed'
                : 'bg-indigo-600 hover:bg-indigo-700'
            }`}
          >
            {isSubmitting ? 'Redeeming...' : 'Redeem Code'}
          </button>
        </div>
      </form>
      
      <div className="mt-6 p-4 bg-indigo-50 rounded-lg">
        <h3 className="font-semibold text-indigo-800 mb-2">How it works:</h3>
        <ol className="list-decimal list-inside text-gray-700 space-y-1">
          <li>Get a reward coupon from your teacher</li>
          <li>Enter the code or scan the QR code</li>
          <li>Instantly receive your XP reward!</li>
        </ol>
      </div>
    </div>
  );
};